/**
 * Card-on-File Consent Guards
 *
 * Decides whether `completeCardOnFile` should record the card authorization
 * for a card just saved through a SetupIntent.
 */

import type { GuardWithMetadata } from "./sms.guard";

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.length > 0;

/**
 * True only when a new SetupIntent was confirmed in this session (POS or
 * Stripe Element) and every field complete-card-setup needs is present, and we
 * have not already recorded it. The saved-card path (USE_SAVED_CARD) clears
 * setupIntentId, so it never records.
 */
export const shouldRecordCardOnFileConsent: GuardWithMetadata = {
  impl: ({ context }) => {
    const orgId = Number(context.orgId);
    return (
      isNonEmptyString(context.setupIntentId) &&
      isNonEmptyString(context.consumerId) &&
      isNonEmptyString(context.userId) &&
      Number.isInteger(orgId) &&
      orgId > 0 &&
      context.cardAuthRecorded !== true
    );
  },
  metadata: {
    displayName: "shouldRecordCardOnFileConsent",
    description:
      "New SetupIntent saved this session and consent not yet recorded",
    requiresContext: [
      "setupIntentId",
      "consumerId",
      "userId",
      "orgId",
      "cardAuthRecorded",
    ],
    category: "context",
  },
};
